import React, { FC, PropsWithChildren } from "react";
import cn from "classnames";

type Props = PropsWithChildren<{
  color?: "Primary" | "Secondary";
  type?: "button" | "submit";
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}>;

const Button: FC<Props> = ({
  color = "Primary",
  type = "button",
  disabled = false,
  onClick,
  children,
}) => {
  return (
    <button
      className={cn(
        "py-2 px-3.5 flex items-center gap-x-2 rounded-md text-sm font-medium transition-colors duration-150",
        color === "Primary"
          ? "bg-vg-blue text-white hover:brightness-105 active:brightness-95"
          : "bg-slate-100 text-slate-700 border border-slate-200 hover:bg-slate-200",
        disabled && "opacity-50 cursor-not-allowed"
      )}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
